import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap'
import Cancel from '@material-ui/icons/Cancel'
import { CircularProgress, Box, MenuItem, Select } from '@material-ui/core'
import Moment from 'react-moment'
import moment from 'moment'

import { MEDIA_PLANNING_SHORTCUT, YT_COMPLIANCE } from '../../constants/commons'
import TopicHelpers from '../../classes/TopicHelpers'
import { TRENDING } from '../../constants/commons'
import * as TLM from '../../constants/tlm'
import AudiencePageOnBoarding from './AudiencePageOnBoarding'
import Spinner from '../Spinner'
import Profile from '../../classes/profile'
import DateHelpers from '../../classes/DateHelpers'
import Thumbnail from '../widgets/Thumbnail'

export default class AudienceHeaderComponent extends React.Component {
  static propTypes = {
    profile: Profile.PropTypes,
    topicDetails: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }).isRequired,
    exportPlan: PropTypes.func.isRequired,
    exportFilteredPlan: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    planExport: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object
    })
  }

  constructor (props) {
    super(props)

    this.state = {
      dropdownOpenFilter: false,
      hideShortcutBanner: false,
      exportCompleted: false
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.planExport && !this.props.planExport.isFetching && prevProps.planExport.isFetching!=this.props.planExport.isFetching) {
      this.setState({ exportCompleted: true })
      setTimeout(() => {
        this.setState({ exportCompleted: false })
      }, 3000)
    }
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }
    const topicName = this.props.topicDetails.details && (this.props.topicDetails.details.display_name ||this.props.topicDetails.details.name)
    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }
    return (
      <div className='shortCutBanner'>
        <span>
          This preview of content analytics for <strong>{topicName}</strong> will expire on&nbsp;
          <Moment format='MM/DD/YYYY'>
            {expires}
          </Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  _renderOnboarding () {
    if (!this.props.shortcut || (this.props.shortcut && this.props.shortcut.target === MEDIA_PLANNING_SHORTCUT)) {
      return null
    }
    if (this.props.topicDetails.isFetching) {
      return (<Spinner />)
    }
    const topic = this.props.topicDetails && this.props.topicDetails.details
    const name = topic && topic.display_name ? topic.display_name : topic && topic.name ? topic.name : ''
    return (
      <AudiencePageOnBoarding
        name={name}
        run={true}
        setScroll={this._setScroll.bind(this)}
        />
    )
  }

  _setScroll () {
    window.scrollTo({
      top: this.scrollRef.current.offsetTop + 200
    })
  }
  render () {
    return (
      <>
        {this._renderOnboarding ()}
        {this._renderShortcut()}
        {this.renderAudienceHeader()}
      </>
    )
  }

  renderAudienceHeader () {
    if (this.props.topicDetails.isFetching) {
      return null
    }
    const details = this.props.topicDetails.details
    const entityLocalization = (details && details.entity_localization_override&& details.entity_localization_override.length > 0) && details.entity_localization_override[0]
    const topic_name = entityLocalization && entityLocalization.display_name ? entityLocalization.display_name : details.display_name || details.name
    const topic_image = entityLocalization && entityLocalization.entity_override_image ? entityLocalization.entity_override_image : details.entity_override_image ? details.entity_override_image : details.thumbnail
    // Hiding this filter for now.  Later we need to work on this
    // const toggleFilters = () => {
    //   this.setState({ dropdownOpenFilter: !this.state.dropdownOpenFilter })
    // }
    const type = TopicHelpers.topicSubTypeFromDetails(details)
    const getNetwork = () => {
      const networkLabel = TopicHelpers.getNetworkLabel(details.labels)
      if (networkLabel && (type === TLM.SHOW || type === TLM.MOVIE)) {
        return (
          <li>{networkLabel}</li>
        )
      }
    }
    const getCategroy = () => {
      const category = TopicHelpers.getCategory(details)
      if (category) {
        return (
          <li>{category}</li>
        )
      }
    }
    const getDate = () => {
      const activeDate = details.entity_localization_override && details.entity_localization_override.length > 0 && details.entity_localization_override[0].active_date ? details.entity_localization_override[0].active_date : details.active_date
      if (activeDate && (type === TLM.SHOW || type === TLM.MOVIE)) {
        const premiereDate = moment(DateHelpers.getDateWithoutTime(activeDate))
        if (DateHelpers.isYearEndDate(premiereDate)) {
          return (<li>Premiere: <Moment format='YYYY'>{premiereDate}</Moment></li>)
        }
        return (<li>Premiere: <Moment format='MM.DD.YYYY'>{premiereDate}</Moment></li>)
      }
      if (activeDate && type === TLM.CHANNEL) {
        return (<li>Publish: {moment(DateHelpers.getDateWithoutTime(activeDate)).format('MM.DD.YYYY')}</li>)
      }
    }
    return (
      <Row className='header audience'>
        <Col>
          <ul className='hFirstRow balanceVerticalAlign'>
            <li className='imgHolder'>
              {this.renderThumbnail(topic_image, topic_name)}
            </li>
            <li>
              <h2 className='title'>{topic_name}</h2>
              <ul className='titleTag'>
                <li>{type}</li>
                {getNetwork()}
                {getCategroy()}
                {getDate()}
              </ul>
            </li>
          </ul>
        </Col>
        <Col xs='12' sm='12' md='auto' lg='auto' xl='auto'>
          {this.renderFilter()}
        </Col>
      </Row>
    )
  }

  renderThumbnail (image, name) {
    return (
      <Thumbnail
        entityOverrideImage={(image && image.indexOf('http') === -1) ? image : null}
        thumbnail={(image && image.indexOf('http') > -1) ? image : null}
        name={name}
        imageClass={'imgThumb'}
        noImgTextClass={'audienceHeaderNoImgText'}
        noImgClass={'audienceHeaderNoImg'}
        divId={'audience_header_img'}
      />
    )
  }

  renderFilter () {
    if (this.props.location && this.props.location.pathname.includes(TRENDING)) {
      return null
    }

    let { profile } = this.props
    if (profile && profile.groups.length > 0 && profile.groups.indexOf(YT_COMPLIANCE) > -1) {
      return null
    }

    return (
      <Fragment>
        <Box className={`${this.state.exportCompleted ?'export-completed' : `${this.props.planExport && this.props.planExport.isFetching ? 'export-icon-fetching' : 'export-icon'}`} topRightActions`}>
          {this.props.planExport && this.props.planExport.isFetching ? (
            <CircularProgress />
          ) : (
            <Select
              labelId='select-filled-label'
              id='select-filled'
              IconComponent={'none'}
              value={''}
            >
              <MenuItem disabled>
                <Box className='d-flex flex-column pt-1'>
                  <span className='optionLabel'>Exports:</span>
                </Box>
              </MenuItem>
              <MenuItem>
                <Box className='d-flex flex-column pt-1'>
                  <span className='optionLabel' onClick={this.props.exportPlan}>
                    Summary Export
                  </span>
                </Box>
              </MenuItem>
              <MenuItem>
                <Box className='d-flex flex-column pt-1'>
                  <span
                    className='optionLabel'
                    onClick={this.props.exportFilteredPlan}
                  >
                    Filtered Export
                  </span>
                </Box>
              </MenuItem>
            </Select>
          )}
        </Box>
      </Fragment>
    )
  }
}
